export default "__VITE_ASSET__CkrseisN__"